import Vue from 'vue';
import VueI18n from 'vue-i18n';
import fr from '../locales/fr/index.js';
import en from '../locales/en/index.js';

Vue.use(VueI18n);

const numberFormats = {
    en: {
        currency: {
            style: 'currency',
            currency: 'CAD',
            currencyDisplay: 'narrowSymbol',
        },
    },
    fr: {
        currency: {
            style: 'currency',
            currency: 'CAD',
            currencyDisplay: 'narrowSymbol',
        },
    },
};

const browserLanguage = (navigator.language || navigator.userLanguage).split('-')[0];

const i18n = new VueI18n({
    locale: browserLanguage === 'fr' ? 'fr' : 'en',
    numberFormats,
    messages: {
        fr,
        en,
    },
});

// Hot Reloading
if (module.hot) {
    module.hot.accept(['../locales/fr', '../locales/en'], () => {
        i18n.setLocaleMessage('en', en);
        i18n.setLocaleMessage('fr', fr);
    });
}

export default i18n;
